import { getIPDetails } from '@/axios/api/mrbox'
import Vue from 'vue'
const staking = {
    state: {
      // 状态内容
      project_key:'fdusd_fdusd',
      userInfo:'',
      storageIP:null,//ip参数
      searchFunnel:['FeaturedBox','MyBoxes'],//需要显示搜索框漏斗的组件列表
      funnel:false,//漏斗的状态
      showSuccessBind:false,//成功为自己制造盒子后显示状态
      yourselfMadeBoxsDetails:{},//自己制作的盒子详情
    },
    mutations: {
        USERINFO(state,info){
            state.userInfo=info
        },
        IPSETINFO(state,info){
            state.storageIP=info
        }
      // mutations
    },
    actions: {
    //获取IP信息
      SetIPDetail({commit}){
        getIPDetails().then(zip=>{
            commit('IPSETINFO',zip)
            Vue.ls.set('IP',zip)
        })
      },
      // actions
      projectKeyStorage(content){
        localStorage.setItem('project_key',content.project_key)
      }
    },
    getters: {
    
    },
  };
  
  export default staking;